/**
 * @description
 * ローカルストレージから値を取得する
 * @param key - ローカルストレージのキー
 * @returns 取得した値
 */
export function getLocalStorage(key: string): string | null {
  return localStorage.getItem(key);
}

/**
 * @description
 * ローカルストレージに値を保存する
 * @param key - ローカルストレージのキー
 * @param value - 保存する値
 */
export function setLocalStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}

/**
 * @description
 * ローカルストレージから値を削除する
 * @param key - ローカルストレージのキー
 */
export function removeLocalStorage(key: string): void {
  localStorage.removeItem(key);
}
